import { render } from "./ResultItem.vue?vue&type=template&id=23f30e45"
import script from "./ResultItem.vue?vue&type=script&lang=js"
export * from "./ResultItem.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__